import { render, staticRenderFns } from "./lang_set.vue?vue&type=template&id=bb5d8204&scoped=true"
import script from "./lang_set.vue?vue&type=script&lang=js"
export * from "./lang_set.vue?vue&type=script&lang=js"
import style0 from "./lang_set.vue?vue&type=style&index=0&id=bb5d8204&prod&lang=less"
import style1 from "./lang_set.vue?vue&type=style&index=1&id=bb5d8204&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5d8204",
  null
  
)

export default component.exports